import RouteMeta from '@/types/RouteMeta'

const dsUnitRoutes = [
  {
    path:
      import.meta.env.VITE_MODE === 'local' ||
      window.location.href.includes(import.meta.env.VITE_B2C_BASE_URL as string)
        ? '/'
        : '/ds',
    name: 'ds',
    redirect: () => ({
      name: 'ds.home',
    }),
    component: () => import('./Index.vue'),
    meta: {
      unitRoute: true,
      navIcon: 'user',
    },
    children: [
      {
        path: 'home',
        name: 'ds.home',
        component: () => import('./views/DsHome.vue'),
        meta: {
          title: 'Home',
          icon: 'home',
          topNav: false,
        } as RouteMeta,
      },
      {
        path: 'study-match',
        redirect: () => ({
          name: 'ds.tips',
        }),
        meta: {},
      },
      {
        path: 'application/search',
        name: 'ds.application.search',
        component: () => import('./views/applications/search/Search.vue'),
        meta: {
          color: 'orange',
          topNav: false,
          title: 'Bewerbungsmappe für Praxispartner erstellen',
          icon: 'handshake',
          step: 1,
        } as RouteMeta,
        children: [
          {
            path: '1',
            name: 'ds.application.search.graduation',
            component: () =>
              import('./views/applications/search/Step1_Graduation.vue'),
          },
          {
            path: '2',
            name: 'ds.application.search.distance',
            component: () =>
              import('./views/applications/search/Step2_Distance.vue'),
          },
          {
            path: '3',
            name: 'ds.application.search.motivation',
            component: () =>
              import('./views/applications/search/Step3_Motivation.vue'),
          },
          {
            path: '4',
            name: 'ds.application.search.documents',
            component: () =>
              import('./views/applications/search/Step4_Documents.vue'),
          },
        ],
      },
      {
        path: 'application/search/5/:jobOpeningId/details',
        redirect: () => ({
          name: 'ds.application.selfmatching.details',
        }),
        meta: {},
      },
      {
        path: 'application/selfmatching/1',
        redirect: () => ({
          name: 'ds.application.selfmatching.overview',
        }),
        meta: {},
      },
      {
        path: 'selfmatching',
        name: 'ds.application.selfmatching',
        redirect: () => ({
          name: 'ds.application.selfmatching.overview',
        }),
        component: () =>
          import('./views/applications/selfmatching/Selfmatching.vue'),
        meta: {
          color: 'blue',
          topNav: false,
          title: 'Praxispartner-Vorschläge',
          icon: 'sign',
          step: 2,
        } as RouteMeta,
        children: [
          {
            path: '',
            name: 'ds.application.selfmatching.overview',
            component: () =>
              import(
                './views/applications/selfmatching/Selfmatching_Overview.vue'
              ),
          },
          {
            path: ':jobOpeningId',
            name: 'ds.application.selfmatching.details',
            component: () =>
              import(
                './views/applications/selfmatching/Selfmatching_Details.vue'
              ),
          },
        ],
      },
      {
        path: 'application/contracts',
        name: 'ds.application.contracts',
        component: () => import('./views/applications/contracts/Contracts.vue'),
        meta: {
          color: 'green',
          topNav: false,
          title: 'Einschreibung',
          icon: 'sign',
          step: 3,
        } as RouteMeta,
        children: [
          {
            path: '1',
            name: 'ds.application.contracts.personal',
            component: () =>
              import('./views/applications/contracts/Step1_Personal.vue'),
          },
          {
            path: '2',
            name: 'ds.application.contracts.documents',
            component: () =>
              import('./views/applications/contracts/Step2_Documents.vue'),
          },
        ],
      },
      {
        path: 'profile',
        name: 'ds.profile',
        redirect: () => ({
          name: 'ds.profile.contact',
        }),
        component: () => import('./views/profile/Profile.vue'),
        meta: {
          color: 'orange',
          topNav: true,
          title: 'Profileinstellungen',
          icon: 'user',
        } as RouteMeta,
        children: [
          {
            path: '1',
            name: 'ds.profile.contact',
            component: () => import('./views/profile/Step1_Contact.vue'),
          },
          {
            path: '2',
            name: 'ds.profile.partner',
            component: () => import('./views/profile/Step2_Partner.vue'),
          },
          {
            path: '3',
            name: 'ds.profile.notifications',
            component: () => import('./views/profile/Step3_Notifications.vue'),
          },
        ],
      },
      {
        path: 'contact',
        name: 'ds.contact',
        redirect: () => ({
          name: 'ds.contact.advisor',
        }),
        component: () => import('./views/contact/Contact.vue'),
        meta: {
          title: 'Kontakt',
          icon: 'envelope',
          color: 'orange',
          topNav: true,
        } as RouteMeta,
        children: [
          {
            path: '1',
            name: 'ds.contact.advisor',
            component: () => import('./views/contact/Step1_Advisor.vue'),
          },
          {
            path: '2',
            name: 'ds.contact.team',
            component: () => import('./views/contact/Step2_Team.vue'),
          },
          {
            path: '3',
            name: 'ds.contact.support',
            component: () => import('./views/contact/Step3_Support.vue'),
          },
        ],
      },
      {
        path: 'iutraining',
        name: 'ds.iutraining',
        component: () => import('./views/IuTrainingView.vue'),
        meta: {
          title: 'IU Bewerbungstraining',
          icon: 'study-owl',
          navItem: true,
          topNav: true,
          topDivider: true,
        } as RouteMeta,
      },
      {
        path: 'tips',
        name: 'ds.tips',
        component: () => import('./views/TipsView.vue'),
        meta: {
          title: 'Tipps & Vorlagen',
          icon: 'checklist',
          navItem: true,
          topNav: true,
        } as RouteMeta,
      },
      {
        path: 'faq',
        name: 'ds.faq',
        component: () => import('./views/FaqView.vue'),
        meta: {
          title: 'Häufig gestellte Fragen',
          icon: 'question-circle',
          navItem: true,
          topNav: true,
        } as RouteMeta,
      },
      {
        path: 'cvgenerator',
        name: 'ds.cvgenerator',
        component: () => import('./views/CvGeneratorView.vue'),
        meta: {
          title: 'Profil Generator',
          icon: 'question-circle',
        } as RouteMeta,
      },
      {
        path: 'bringafriend',
        name: 'ds.baf',
        component: () => import('./views/BringAFriendView.vue'),
        meta: {
          title: 'Freunde werben',
          icon: 'checklist',
        } as RouteMeta,
      },
      {
        path: 'documents-builder',
        component: () =>
          import('./views/documents-builder/DocsBuilderLayout.vue'),
        meta: {
          title: 'Bewerbungsunterlagen',
          icon: 'checklist',
        } as RouteMeta,
        children: [
          {
            path: '',
            name: 'ds.documents-builder',
            component: () => import('./views/documents-builder/Index.vue'),
          },
          {
            path: 'personal-data',
            name: 'ds.documents-builder.personal-data',
            component: () => import('./forms/PersonalDataForm.vue'),
            meta: {
              title: 'Persönliche Daten',
            } as RouteMeta,
          },
        ],
      },
    ],
  },
]

export default dsUnitRoutes
